/**
 * storedOpen — a per-viewer open / closed flag in localStorage, for
 * collapsible UI (room pane sections, room charts).
 *
 * A convenience only: every access is wrapped, and callers fall back to their
 * default whenever storage is unavailable (private window, blocked site data).
 */

/** The stored flag under `key`, or null when absent, unreadable or not a flag. */
export function readStoredOpen(key: string): boolean | null {
  try {
    const raw = window.localStorage.getItem(key)
    if (raw === '1') {
      return true
    }
    if (raw === '0') {
      return false
    }
    return null
  } catch {
    return null
  }
}

/** Stores the flag under `key`; a storage failure is ignored (the default applies next time). */
export function writeStoredOpen(key: string, isOpen: boolean): void {
  try {
    window.localStorage.setItem(key, isOpen ? '1' : '0')
  } catch {
    // Storage unavailable (private window, blocked site data): the default applies next time.
  }
}
